import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=519e7aee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519e7aee')) {
      api.createRecord('519e7aee', component.options)
    } else {
      api.reload('519e7aee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=519e7aee&", function () {
      api.rerender('519e7aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jFQrrib2pgoc/JS/pricehelp.vue"
export default component.exports